export default __webpack_public_path__ + "static/media/thunder.e8206c93.wav";